import React, { useCallback, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import RenderSelectBoxCell from "../../common/RenderCell";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Button } from 'devextreme-react';
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../common/GridLayout";
import TextArea from 'devextreme-react/text-area';

function Synonym(props) {
    const gridKey = props.gridKey;
    const dataGrid = useRef(null);
    let accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    
    
    const dataSource = createStore({
        key: 'ROWID',
        loadParams:
        {
            R_IDENTITY : function ()
            {
                return props.formFields.ROWID;
            },
            IDTYPE: function ()
            {
                return props.IdType;
            },
            
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/id/Synonym/GetSynonyms`,
        insertUrl: `${window._env_.REACT_APP_APIS}/id/Synonym/InsertSynonym`,
        updateUrl: `${window._env_.REACT_APP_APIS}/id/Synonym/UpdateSynonym`,
        deleteUrl: `${window._env_.REACT_APP_APIS}/id/Synonym/DeleteSynonym`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
            };
        }
    });

    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }

    const rowInserting = (e) => {
        e.data['R_IDENTITY'] = props.formFields.ROWID;
        e.data['IDTYPE'] = props.IdType;
    };

    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    };

    
  const deleteRecords= () => {
        var that = this;
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                (
                    `${window._env_.REACT_APP_APIS}/id/Synonym/DeleteSynonyms`,
                    selectedItemKeys,
                    {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                    }
                )
                .then((res) => {
                    dataGrid.current.instance().endCustomLoading();
                    dataGrid.current.instance().refresh();
                })
                .catch((err) => {
                    dataGrid.current.instance().endCustomLoading();
                    alert(err, "Error");
                });

            }
        });

    };

    const renderCommentCell = (cellElement) => {
        const currentValue = cellElement.row.data?.COMMENT || '';
        return (
            <TextArea
                defaultValue={currentValue}
                onValueChanged={async (e) => {
                    cellElement.setValue(e.value);
                }}
                onKeyDown={async (e) => {
                    if(e.event.key == "Enter")
                    {
                        e.event.stopPropagation();
                    }
                }}
                label="."
                labelMode='static'
                stylingMode='outlined'
            >
            </TextArea>
        );
    }

    return (
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            id="gridContainer"
            ref={dataGrid}
            selectedRowKeys={selectedItemKeys}
            showBorders={true}
            rowAlternationEnabled={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnAutoWidth={true}
            onSelectionChanged={handleCellValueChanged}
            height="100%"
            key={"rowid"}
            onRowInserting={rowInserting}
            onContentReady={onContentReady}
        >
            <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
            >
                <ColumnChooserSearch
                    enabled={true}
                    editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
            />
            <Scrolling mode="standard" />
            <Selection mode="multiple" />
            <Export enabled={true} allowExportSelectedData={true} />
            <Editing
                mode="cell"
                refreshMode="repaint"
                allowUpdating={true}
                allowAdding={true}
                allowDeleting={true}
            />
            <FilterRow visible={true} />
            <Column dataField="NAME" caption="Name" dataType="string" editorOptions={{ maxLength:40 }}>
                <RequiredRule message="Name is required" />
            </Column>
            <Column dataField="ADDRESS_1" caption="Address - 1" dataType="string" editorOptions={{ maxLength:40 }}/>
            <Column dataField="ADDRESS_2" caption="Address - 2" dataType="string" editorOptions={{ maxLength:40 }}/>
            <Column dataField="CITY" caption="City" dataType="string" editorOptions={{ maxLength:30 }}/>
            <Column dataField="STATE" caption="State" dataType="string" editorOptions={{ maxLength:5 }}/>
            <Column dataField="ZIP" caption="Zip" dataType="string" editorOptions={{ maxLength:15 }}/>
            <Column dataField="COMMENT" caption="Comment" editCellRender={renderCommentCell}
                setCellValue={(rowData, newValue) => {
                    rowData.COMMENT = newValue;
                }}>
            </Column>
            <Column dataField="USERDEFINEDCODE_1" caption="Code 1" allowSorting={false}
                editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetCodes`,
                        loadParams: {
                            codeType: function () {
                                return 'DA';
                            }
                        },
                        key: "name",
                        displayExpr: "name",
                        valueExpr: "name",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.USERDEFINEDCODE_1,
                        sort: [{ selector: "name", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                setCellValue={(rowData, newValue) => {
                    rowData.USERDEFINEDCODE_1 = newValue.text;
                }}
            >
            </Column>
            <Toolbar>
                <Item
                    name="addRowButton"
                />
                <Item location="after">
                    <Button
                        onClick={deleteRecords}
                        icon="trash"
                        disabled={!selectedItemKeys.length}
                    />
                </Item>
                <Item location="after">
                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
                <Item name="exportButton" />
                <Item name="columnChooserButton" />
            </Toolbar>
        </DataGrid>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Synonym);